<template>
    <teleport to="head">
        <link rel="canonical" :href="$route.path" />
        <meta name="keywords" :content="metaKeyword">
        <meta name="description" :content="metaDescription">
        <meta name="author" content="HGSHYDRO">
    <meta name="publisher" content="HGSHYDRO">
    </teleport>
</template>

<script>
export default {
    name: 'WishlistSchemaJson',
    props: ['metaKeyword', 'metaDescription'],
    data() {
        return {
           wishlistMetaKeyword: "",
           wishlistMetaDescription: ""
        }
    },
    watch:{
        metaKeyword: {
            handler: function(metaKeyword) {
                this.wishlistMetaKeyword = metaKeyword;
            }
        },
        metaDescription: {
            handler: function(metaDescription) {
                this.wishlistMetaDescription = metaDescription;
            }
        }
    }
}   
</script>
